// extracted by mini-css-extract-plugin
export default {"eventsGrid":"Report_eventsGrid__4qWBK","tableHeader":"Report_tableHeader__YRWi7"};